module.exports = __webpack_public_path__ + "static/media/plus-blue-40.ae8c3a29.svg";